import { Provider } from '@angular/core';
import { DECLARATIVE_FORMS_VALIDATOR_TOKEN } from '@fmnts/declarative-forms/core';
import { TaxValidationBuilder } from './tax-validation-builder.service';

/**
 * Module that provides functionality for tax-related things.
 */
export function provideDeclarativeFormsTaxFeature(): Provider {
  return [
    TaxValidationBuilder,
    {
      provide: DECLARATIVE_FORMS_VALIDATOR_TOKEN,
      useExisting: TaxValidationBuilder,
      multi: true,
    },
  ];
}
